import lodash from 'lodash'
const mutations = {
  setServer(state, server) {
    state.server = server
  },
  setServerStatus(state, status) {
    state.server.status = status
  },
  setDefaultServer(state, server) {
    state.defaultServer = server
  },
  clear(state) {
    state.server = {}
  },
  setGeneralSettings({ server }, { host, serverId, newserverId, description, model }) {
    server.host = host
    server.description = description
    server.serverId = serverId || newserverId || server.serverId
    server.model = model
  },
  addInput(state, input) {
    state.server.inputs.push(input)
  },
  addPrepocessor(state, [inputName, index, processor]) {
    const input = lodash.find(state.server.inputs, {
      inputName
    })
    if (index === -1) {
      input.preProcessors.unshift(processor)
    } else {
      input.preProcessors = [
        ...input.preProcessors.slice(0, index + 1),
        processor,
        ...input.preProcessors.slice(index + 1)
      ]
    }
  },
  addPostprocessor(state, [inputName, index, processor]) {
    const input = lodash.find(state.server.inputs, {
      inputName
    })
    if (index === -1) {
      input.postProcessors.unshift(processor)
    } else {
      input.postProcessors = [
        ...input.postProcessors.slice(0, index + 1),
        processor,
        ...input.postProcessors.slice(index + 1)
      ]
    }
  },
  addOutput(state, [inputName, processor]) {
    lodash
      .find(state.server.inputs, {
        inputName
      })
      .output.push(processor)
  },
  removeInput(state, inputName) {
    const index = lodash.findIndex(state.server.inputs, {
      inputName
    })
    if (~index) {
      state.server.inputs.splice(index, 1)
    }
  },
  removePreprocessor(state, [inputName, index]) {
    const input = lodash.find(state.server.inputs, {
      inputName
    })
    input.preProcessors.splice(index, 1)
  },
  removePostprocessor(state, [inputName, index]) {
    const input = lodash.find(state.server.inputs, {
      inputName
    })
    input.postProcessors.splice(index, 1)
  },
  removeOutput(state, [inputName, index]) {
    const input = lodash.find(state.server.inputs, {
      inputName
    })
    input.output.splice(index, 1)
  },
  setActiveInputName(state, inputName) {
    state.activeInputName = inputName
  },

  savePreprocessor(state, [inputName, index, preprocessor]) {
    const input = lodash.find(state.server.inputs, {
      inputName
    })
    input.preProcessors[index] = preprocessor
  },
  savePostprocessor(state, [inputName, index, postprocessor]) {
    const input = lodash.find(state.server.inputs, {
      inputName
    })
    input.postProcessors[index] = postprocessor
  },
  saveOutput(state, [inputName, index, output]) {
    const input = lodash.find(state.server.inputs, {
      inputName
    })
    input.output[index] = output
  }
}
export default mutations
